import React from "react"
import { type RouteObject } from "react-router-dom"

import { RoutesPaths } from "../../../../constants/routes.ts"
import { CompanyDefaultsGate } from "../../../Settings/components/common/CompanyDefaultsGate.tsx"
import { allowsBlock } from "../../../Settings/components/common/company-defaults-access.ts"
import { lazyPage } from "../lazyPage.tsx"

const DocumentContractCreatePage = lazyPage(
  () =>
    import("../../../DocumentTemplates/DocumentPages/DocumentContractCreatePage.tsx")
)
const DocumentContractEditPage = lazyPage(
  () =>
    import("../../../DocumentTemplates/DocumentPages/DocumentContractEditPage.tsx")
)
const DocumentProposalCreatePage = lazyPage(
  () =>
    import("../../../DocumentTemplates/DocumentPages/DocumentProposalCreatePage.tsx")
)
const DocumentProposalEditPage = lazyPage(
  () =>
    import("../../../DocumentTemplates/DocumentPages/DocumentProposalEditPage.tsx")
)
const DocumentTemplateAddPage = lazyPage(
  () =>
    import("../../../DocumentTemplates/DocumentTemplatePages/DocumentTemplateAddPage.tsx")
)
const DocumentTemplateEditPage = lazyPage(
  () =>
    import("../../../DocumentTemplates/DocumentTemplatePages/DocumentTemplateEditPage.tsx")
)

const allowsDocumentTemplateCreate = allowsBlock("document_templates", "create")
const allowsDocumentTemplateEdit = allowsBlock("document_templates", "edit")

export const templatesRoutes: RouteObject[] = [
  {
    path: RoutesPaths.documentTemplates.add,
    element: (
      <CompanyDefaultsGate allows={allowsDocumentTemplateCreate}>
        <DocumentTemplateAddPage />
      </CompanyDefaultsGate>
    )
  },
  {
    path: RoutesPaths.documentTemplates.edit(":id"),
    element: (
      <CompanyDefaultsGate allows={allowsDocumentTemplateEdit}>
        <DocumentTemplateEditPage />
      </CompanyDefaultsGate>
    )
  },
  // Proposal Document
  {
    path: RoutesPaths.proposalDocument.create(":templateId", ":leadId"),
    element: <DocumentProposalCreatePage />
  },
  {
    path: RoutesPaths.proposalDocument.edit(":id"),
    element: <DocumentProposalEditPage />
  },
  // Contract Document
  {
    path: RoutesPaths.contractDocument.create.path,
    element: <DocumentContractCreatePage />
  },
  {
    path: RoutesPaths.contractDocument.edit(":id"),
    element: <DocumentContractEditPage />
  }
]
